import { Field as FieldPrimitive } from "@base-ui/react/field";
import { cn } from "cn";

/**
 * Обёртка над `@base-ui/react/field`: `Root`/`Label`/`Description`/`Error`
 * одного поля формы. Ассоциация `htmlFor`, `aria-describedby` и
 * `aria-invalid` между этими частями и контролом собирается самим
 * примитивом — достаточно, чтобы контролом было базовое поле ввода Base UI
 * (наш `Input` — именно такое, он сам рендерит `Field.Control`).
 * `Field.Control` отдельно не оборачиваем: не понадобился ни одному экрану,
 * а обёртку несложно завести по этому же файлу, когда понадобится контрол
 * не на базе `Input`.
 */
function Field({ className, ...props }: FieldPrimitive.Root.Props) {
  return (
    <FieldPrimitive.Root
      data-slot="field"
      className={cn("flex flex-col gap-1.5", className)}
      {...props}
    />
  );
}

function FieldLabel({ className, ...props }: FieldPrimitive.Label.Props) {
  return (
    <FieldPrimitive.Label
      data-slot="field-label"
      className={cn("text-sm leading-none font-medium select-none", className)}
      {...props}
    />
  );
}

function FieldDescription({ className, ...props }: FieldPrimitive.Description.Props) {
  return (
    <FieldPrimitive.Description
      data-slot="field-description"
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  );
}

/**
 * `match` не передаём значением по умолчанию: у него нет валидации Base UI
 * (`validate`/`pattern` и т.п.), содержимое приходит извне — от исхода
 * запроса. Место использования решает, когда сообщение показывать `match={true}`),
 * а когда — по встроенной проверке.
 */
function FieldError({ className, ...props }: FieldPrimitive.Error.Props) {
  return (
    <FieldPrimitive.Error
      data-slot="field-error"
      role="alert"
      className={cn("text-sm text-destructive", className)}
      {...props}
    />
  );
}

export { Field, FieldDescription, FieldError, FieldLabel };
